import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=288feaa2"
import script from "./PrintButton.vue?vue&type=script&lang=ts"
export * from "./PrintButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports